module.exports = __webpack_public_path__ + "b9cc884abb1f475b65ffeac85b4defef.png";